export const ADMIN_BRAND_PAGES_PATH = `/admin/brand_pages`

export const PAGE_SETUP_FIELD_ID = 'pageSetup'

export const LOGO_BANNER_FIELD_ID = 'blocks[0]'
export const DEFAULT_FIELD_NAMES = [LOGO_BANNER_FIELD_ID, PAGE_SETUP_FIELD_ID]
